import { c as _c } from "react/compiler-runtime";
import { ArrowUp, ArrowUpRight, Icons, Sidebar, SidebarContent, SidebarFooter, SidebarGroup, SidebarGroupContent, SidebarHeader, SidebarMenu, SidebarMenuButton, SidebarMenuItem, SidebarTrigger, useSidebar } from '@/components';
import { Badge } from '@/components/ui/Badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/Dialog';
import { WhatsNewModal } from '@/components/layout/WhatsNewModal';
import { useI18n } from '@/context/I18nProvider';
import { usePendingReviewsCount } from '@/hooks/usePendingReviewsCount';
import { useWaitingAiResponseCount } from '@/hooks/useWaitingAiResponseCount';
import { cn } from '@/lib/utils';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useRouter } from 'next/router';
import { createElement, MouseEvent, useEffect, useState } from 'react';
type NavigationItem = {
  href: string;
  labelKey: string;
  icon: keyof typeof Icons;
  tooltipKey: string;
  openInNewTab?: boolean;
  hide?: boolean;
};
const navigationItemsMain: NavigationItem[] = [{
  href: '/conversations',
  labelKey: 'navigation.conversations',
  icon: 'DoubleConversation',
  tooltipKey: 'navigation.conversations'
}, {
  href: '/analytics',
  labelKey: 'navigation.analytics',
  icon: 'AnalyticsSidebar',
  tooltipKey: 'navigation.analytics'
}, {
  href: '/agents',
  labelKey: 'navigation.agents',
  icon: 'AgentSidebar',
  tooltipKey: 'navigation.agents'
}, {
  href: '/sequences',
  labelKey: 'navigation.sequences',
  icon: 'SequencesSidebar',
  tooltipKey: 'navigation.sequences'
}, {
  href: '/campaigns',
  labelKey: 'navigation.campaigns',
  icon: 'CampaignSidebar',
  tooltipKey: 'navigation.campaigns'
}, {
  href: '/integrations',
  labelKey: 'navigation.integrations',
  icon: 'FineTuning',
  tooltipKey: 'navigation.integrations'
}, {
  href: '/conversation-improvements',
  labelKey: 'navigation.conversationImprovements',
  icon: 'MagicWand',
  tooltipKey: 'navigation.conversationImprovements'
}];
const footerItemsMain: NavigationItem[] = [{
  href: '#whats-new',
  labelKey: 'navigation.whatsNew',
  icon: 'Sparkles',
  tooltipKey: 'navigation.whatsNew'
}, {
  href: '/referral',
  labelKey: 'referral.title',
  icon: 'Heart',
  tooltipKey: 'referral.title'
}, {
  href: '#earn-credits',
  labelKey: 'navigation.earnCredits',
  icon: 'Gift',
  tooltipKey: 'navigation.earnCredits'
},
// {
//   href: 'https://orsayai.canny.io/feature-requests',
//   labelKey: 'navigation.requestFeature',
//   icon: 'MagicWand',
//   tooltipKey: 'navigation.requestFeature',
//   openInNewTab: true,
// },
{
  href: 'https://docs.orsay.ai/',
  labelKey: 'navigation.documentation',
  icon: 'BookOpen',
  tooltipKey: 'navigation.documentation',
  openInNewTab: true
}];
const footerItemsSettings: NavigationItem[] = [{
  href: '/contact-support',
  labelKey: 'navigation.contactSupport',
  icon: 'Calendar',
  tooltipKey: 'navigation.contactSupport'
},
// {
//   href: 'https://orsayai.canny.io/feature-requests',
//   labelKey: 'navigation.requestFeature',
//   icon: 'MagicWand',
//   tooltipKey: 'navigation.requestFeature',
//   openInNewTab: true,
// },
{
  href: 'https://docs.orsay.ai/',
  labelKey: 'navigation.documentation',
  icon: 'BookOpen',
  tooltipKey: 'navigation.documentation',
  openInNewTab: true
}];
const accountItemsSettings: NavigationItem[] = [{
  href: '/settings/account/profile',
  labelKey: 'settings.profile',
  icon: 'User3',
  tooltipKey: 'settings.profile'
}, {
  href: '/settings/account/password',
  labelKey: 'settings.password',
  icon: 'Key3',
  tooltipKey: 'settings.password'
}];
const workspaceItemsSettings: NavigationItem[] = [
// {
//   href: '/settings',
//   labelKey: 'settings.general',
//   icon: 'General',
//   tooltipKey: 'settings.general',
// },
{
  href: '/settings/workspace/members',
  labelKey: 'settings.members',
  icon: 'TripleUser',
  tooltipKey: 'settings.members'
}, {
  href: '/settings/workspace/billing',
  labelKey: 'billing.title',
  icon: 'Billing',
  tooltipKey: 'billing.title'
}, {
  href: '/settings/workspace/conversations',
  labelKey: 'settings.conversations',
  icon: 'DoubleConversation',
  tooltipKey: 'settings.conversations'
}, {
  href: '/settings/workspace/api-keys',
  labelKey: 'settings.apiKeys',
  icon: 'Key3',
  tooltipKey: 'settings.apiKeys'
}
// {
//   href: '/settings/plans',
//   labelKey: 'settings.plans',
//   icon: 'Plans',
//   tooltipKey: 'settings.plans',
// },
];
const navigationItemsSettings: NavigationItem[] = [...accountItemsSettings, ...workspaceItemsSettings, ...footerItemsSettings];
const AppSidebar = () => {
  const $ = _c(51);
  const router = useRouter();
  const {
    state: sidebarState
  } = useSidebar();
  const currentPath = usePathname();
  const {
    t
  } = useI18n();
  const pendingReviewsCount = usePendingReviewsCount();
  const waitingAiResponseCount = useWaitingAiResponseCount();
  const filterNavItems = _temp2;
  const [setting, setSetting] = useState(false);
  const [earnCreditsOpen, setEarnCreditsOpen] = useState(false);
  const [whatsNewOpen, setWhatsNewOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = navigationItemsMain.filter(_temp3);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [navigationItems, setNavigationItems] = useState(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = footerItemsMain.filter(_temp4);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [footerItems, setFooterItems] = useState(t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = workspaceItemsSettings.filter(_temp5);
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [workspaceItems, setWorkspaceItemsSettings] = useState(t2);
  let t3;
  if ($[3] !== router) {
    t3 = () => {
      router.push("/conversations");
    };
    $[3] = router;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleBack = t3;
  let t4;
  if ($[5] !== currentPath) {
    t4 = href => {
      if (href === "/") {
        return currentPath === "/";
      }
      return currentPath.startsWith(href);
    };
    $[5] = currentPath;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const isActive = t4;
  let t5;
  if ($[7] !== currentPath) {
    t5 = href_0 => {
      const normalize = _temp6;
      return normalize(currentPath) === normalize(href_0);
    };
    $[7] = currentPath;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const isExactActivePage = t5;
  let t6;
  if ($[9] !== isExactActivePage) {
    t6 = (e, href_1) => {
      if (href_1 === "#earn-credits") {
        e.preventDefault();
        setEarnCreditsOpen(true);
        return;
      }
      if (href_1 === "#whats-new") {
        e.preventDefault();
        setWhatsNewOpen(true);
        return;
      }
      if (isExactActivePage(href_1)) {
        e.preventDefault();
        return;
      }
    };
    $[9] = isExactActivePage;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const handleClick = t6;
  let t7;
  let t8;
  if ($[11] !== router.route) {
    t7 = () => {
      const isSettingsRoute = navigationItemsSettings.some(item_3 => router.route.startsWith(item_3.href));
      if (isSettingsRoute) {
        setSetting(true);
        setNavigationItems(accountItemsSettings.filter(_temp7));
        setFooterItems(footerItemsSettings);
        setWorkspaceItemsSettings(workspaceItemsSettings);
      } else {
        setSetting(false);
        setNavigationItems(filterNavItems(navigationItemsMain));
        setFooterItems(footerItemsMain);
        setWorkspaceItemsSettings([]);
      }
    };
    t8 = [router.route];
    $[11] = router.route;
    $[12] = t7;
    $[13] = t8;
  } else {
    t7 = $[12];
    t8 = $[13];
  }
  useEffect(t7, t8);
  let t9;
  if ($[14] !== handleClick || $[15] !== isActive || $[16] !== isExactActivePage || $[17] !== pendingReviewsCount || $[18] !== t || $[19] !== waitingAiResponseCount) {
    t9 = items_0 => <SidebarMenu>{items_0.map(item_5 => <SidebarMenuItem key={item_5.href}><Link href={item_5.href} passHref={true} target={item_5.openInNewTab ? "_blank" : undefined} rel={item_5.openInNewTab ? "noopener noreferrer" : undefined} onClick={e_0 => handleClick(e_0, item_5.href)}><SidebarMenuButton tooltip={t(item_5.tooltipKey as any)} className={cn(isActive(item_5.href) && "bg-accent text-primary hover:text-primary hover:bg-accent active:text-primary active:bg-accent", isExactActivePage(item_5.href) && "cursor-default", item_5.labelKey === "auth.signOut" && "text-[#EF4444]")}>{createElement(Icons[item_5.icon], {
              className: cn("size-4 transition-colors", item_5.labelKey === "auth.signOut" && "text-[#EF4444]")
            })}<span className="whitespace-nowrap">{t(item_5.labelKey as any)}</span>{item_5.href === "/conversations" && waitingAiResponseCount > 0 && <Badge className="ml-auto h-5 min-w-5 px-1.5 text-[10px] font-semibold text-purple-700 bg-purple-100 hover:bg-purple-100 border-0">{waitingAiResponseCount}</Badge>}{item_5.href === "/conversation-improvements" && pendingReviewsCount > 0 && <Badge variant="destructive" className="ml-auto h-5 min-w-5 px-1.5 text-[10px] font-semibold">{pendingReviewsCount}</Badge>}{item_5.openInNewTab && <ArrowUpRight className="ml-auto size-4" />}</SidebarMenuButton></Link></SidebarMenuItem>)}</SidebarMenu>;
    $[14] = handleClick;
    $[15] = isActive;
    $[16] = isExactActivePage;
    $[17] = pendingReviewsCount;
    $[18] = t;
    $[19] = waitingAiResponseCount;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const renderNavItems = t9;
  let t10;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setWhatsNewOpen(false);
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== whatsNewOpen) {
    t11 = <WhatsNewModal forceOpen={whatsNewOpen} onForceClose={t10} />;
    $[22] = whatsNewOpen;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t) {
    t12 = t("navigation.earnCredits");
    $[24] = t;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t12) {
    t13 = <DialogHeader className="shrink-0 px-6 pt-6 pb-0"><DialogTitle className="text-base font-semibold text-[#1F2937]">{t12}</DialogTitle></DialogHeader>;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== t) {
    t14 = t("navigation.earnCredits");
    $[28] = t;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== t14) {
    t15 = <div className="flex-1 min-h-0 px-6 pb-6 pt-2"><iframe src="https://form.fillout.com/t/oBQprLUsKCus" className="w-full h-full rounded-lg border-0" title={t14} /></div>;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t13 || $[33] !== t15) {
    t16 = <DialogContent className="max-w-2xl h-[85vh] p-0 gap-0 overflow-hidden flex flex-col">{t13}{t15}</DialogContent>;
    $[32] = t13;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== earnCreditsOpen || $[36] !== t16) {
    t17 = <Dialog open={earnCreditsOpen} onOpenChange={setEarnCreditsOpen}>{t16}</Dialog>;
    $[35] = earnCreditsOpen;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== footerItems || $[39] !== handleBack || $[40] !== navigationItems || $[41] !== renderNavItems || $[42] !== setting || $[43] !== sidebarState || $[44] !== t || $[45] !== workspaceItems) {
    t18 = <Sidebar variant="inset" collapsible="icon" className="h-full">{!setting ? <><SidebarHeader><SidebarTrigger /></SidebarHeader><SidebarContent><SidebarGroup><SidebarGroupContent>{renderNavItems(navigationItems)}</SidebarGroupContent></SidebarGroup></SidebarContent><SidebarFooter><SidebarGroup><SidebarGroupContent>{renderNavItems(footerItems)}</SidebarGroupContent></SidebarGroup></SidebarFooter></> : <><SidebarHeader className="p-2"><SidebarTrigger /><SidebarMenuButton tooltip={t("common.exitSettings")} onClick={handleBack} className="flex items-center gap-1.5 px-1.5 text-[13px] font-medium text-[#1F2937] hover:text-[#1F2937]/80"><ArrowUp className="size-4" /><span className="whitespace-nowrap">{t("common.back")}</span></SidebarMenuButton></SidebarHeader><SidebarContent><SidebarGroup><SidebarGroupContent className={cn(sidebarState === "expanded" && "space-y-6 px-3")}><div className="space-y-2">{sidebarState === "expanded" ? <div className="flex items-center gap-1.5 px-1.5 text-[13px] font-medium text-[#9CA3AF] cursor-default">{t("settings.account")}</div> : null}{renderNavItems(navigationItems)}</div><div className="space-y-2">{sidebarState === "expanded" ? <div className="flex items-center gap-1.5 px-1.5 text-[13px] font-medium text-[#9CA3AF] cursor-default">{t("settings.workspace")}</div> : null}{renderNavItems(workspaceItems)}</div></SidebarGroupContent></SidebarGroup></SidebarContent><SidebarFooter><SidebarGroup><SidebarGroupContent>{renderNavItems(footerItems)}</SidebarGroupContent></SidebarGroup></SidebarFooter></>}</Sidebar>;
    $[38] = footerItems;
    $[39] = handleBack;
    $[40] = navigationItems;
    $[41] = renderNavItems;
    $[42] = setting;
    $[43] = sidebarState;
    $[44] = t;
    $[45] = workspaceItems;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  let t19;
  if ($[47] !== t11 || $[48] !== t17 || $[49] !== t18) {
    t19 = <>{t11}{t17}{t18}</>;
    $[47] = t11;
    $[48] = t17;
    $[49] = t18;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  return t19;
};
export { AppSidebar };
function _temp(item) {
  return !item.hide;
}
function _temp2(items) {
  return items.filter(_temp);
}
function _temp3(item_0) {
  return !item_0.hide;
}
function _temp4(item_1) {
  return !item_1.hide;
}
function _temp5(item_2) {
  return !item_2.hide;
}
function _temp6(path) {
  return path.replace(/\/$/, "");
}
function _temp7(item_4) {
  return !item_4.hide;
}